// extracted by mini-css-extract-plugin
var _1 = "PreferencesSettings_cell__A3-U3";
var _2 = "PreferencesSettings_container__EyqA9";
export { _1 as "cell", _2 as "container" }
